import PosthogService from '~/services/posthog/PosthogService';

export function fireMenuBarScheduleClicked(): void {
  PosthogService.getInstance().track('dental_portal:menu_bar:schedule_clicked');
}
